import { Col, Menu, Row } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import { getProjectService } from "../../backend";
import { IProjectDetails } from "../../types";

export default function ProjectSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();
    const { projectDetails } = useOutletContext<{ projectDetails: IProjectDetails }>();
    const [activeTab, setActiveTab] = useState("general");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "general");

        const loadData = async () => {
            await getProjectService().getUsers(projectId!);
        }
        loadData();
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                >
                    <Menu.Item key="general">General</Menu.Item>
                    <Menu.Item key="usage">Plan usage</Menu.Item>
                    <Menu.Item key="members">Members</Menu.Item>
                    <Menu.Item key="billing">Billing</Menu.Item>
                </Menu>
            </Col>
            <Col span={18}>
                <Outlet context={{ projectDetails }} />
            </Col>
        </Row >
    )
}